import { AppLayout } from "@/components/layout/app.layout";
import { useAuth } from "@/providers/auth.provider";
import { Navigate, Outlet } from "react-router-dom";

export function ProtectedRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  if (user.needToChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  return <AppLayout />;
}
